import React from 'react'

const HomeLogo = () => {
  return (
    <div>
      <img src={"various/logotitle.webp"}/>
    </div>
  )
}

export default HomeLogo